/**
 * @generated SignedSource<<6f7e572d46c92e59fa6cca35448c5f29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "routes",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConnectionsRouteDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Booklet",
        "kind": "LinkedField",
        "name": "upsertBookletRoute",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConnectionsRouteDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Booklet",
        "kind": "LinkedField",
        "name": "upsertBookletRoute",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "44fc22f217413dd89301b2f7d73dcf1d",
    "id": null,
    "metadata": {},
    "name": "ConnectionsRouteDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ConnectionsRouteDeleteMutation(\n  $id: ID\n  $input: UpsertBookletRouteInput!\n) {\n  upsertBookletRoute(id: $id, input: $input) {\n    routes\n    id\n  }\n}\n"
  }
};
})();

node.hash = "b5b883aab6d0f16feb1993d4990a44b1";

module.exports = node;
